import React, { useEffect, useState } from "react";
import { Form, Container } from "react-bootstrap";
import Select from "react-select";
import "./Modify_Bank_Information.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import {
  faCamera,
  faUpload,
  faCloudUploadAlt,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GetAllBanks } from "../../features/wallet/slice";
import { SubmitModifyBankInformation } from "../../features/support/slice";
import Successfull_strip_modal from "../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";

const modificationOptions = [
  { value: "wrong_name", label: "Wrong Beneficiary Name" },
  { value: "wrong_bank_number", label: "Wrong Bank Account Number" },
  { value: "change_new_bank", label: "Change New Bank" },
];

const uploadFields = [
  { id: "identity_card", label: "Identity Card", mandatory: true, isFile: false, accept: "image/*" },
  { id: "new_identity_card", label: "NEW Identity Card *for change bank with different beneficiary name*", mandatory: true, isFile: false, accept: "image/*" },
  { id: "old_passbook", label: "OLD Passbook / Digital Banking", mandatory: true, isFile: false, accept: "image/*" },
  { id: "new_passbook", label: "NEW Passbook / Digital Banking", mandatory: false, isFile: false, accept: "image/*" },
  { id: "latest_deposit_receipt_1", label: "Latest Deposit Receipt Proof 1", mandatory: true, isFile: false, accept: "/*" },
  { id: "latest_deposit_receipt_2", label: "Latest Deposit Receipt Proof 2", mandatory: false, isFile: false, accept: "/*" },
  { id: "pdf_file", label: "PDF File", mandatory: false, isFile: true, accept: "application/pdf" },
  {
    id: "video_holding",
    label: "Video holding : Identity Card, Passbook, Piece of paper with today's date written on it",
    mandatory: true,
    isFile: true
    , accept: "video/*"
  },
];

const requiredFileIds = ["identity_card", "new_identity_card", "old_passbook", "latest_deposit_receipt_1", "video_holding"];

function Modify_Bank_Information() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  // ─── Files & Previews State ────────────────────────────
  const [files, setFiles] = useState({
    identity_card: null,
    new_identity_card: null,
    old_passbook: null,
    new_passbook: null,
    latest_deposit_receipt_1: null,
    latest_deposit_receipt_2: null,
    pdf_file: null,
    video_holding: null,
  });

  const [previews, setPreviews] = useState({
    identity_card: null,
    new_identity_card: null,
    old_passbook: null,
    new_passbook: null,
    latest_deposit_receipt_1: null,
    latest_deposit_receipt_2: null,
    pdf_file: null,
    video_holding: null,
  });

  const [fileErrors, setFileErrors] = useState({});

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      modification_type: null,
      bank_id: null,
      new_bank_name: "",
      new_beneficiary_name: "",
      new_account_no: "",
      new_ifsc_code: "",
    },
  });

  const allBanks = useSelector((state) => state.wallet.banks);

  useEffect(() => {
    dispatch(GetAllBanks({}));
  }, [dispatch]);


  const handleFileChange = (e, key) => {
    const file = e.target.files[0];
    if (!file) return;

    setFiles((prev) => ({
      ...prev,
      [key]: file,
    }));

    setPreviews((prev) => ({
      ...prev,
      [key]: file.type.startsWith("image") || file.type.startsWith("video")
        ? URL.createObjectURL(file)
        : "file_uploaded",
    }));

    setFileErrors((prev) => ({
      ...prev,
      [key]: null,
    }));

    e.target.value = "";

  };

  const validateFiles = () => {
    const newErrors = {};
    requiredFileIds.forEach((id) => {
      if (!files[id]) {
        const field = uploadFields.find((f) => f.id === id);
        newErrors[id] = `${field?.label} is required`;
      }
    });
    setFileErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onSubmit = async (data) => {
    try {
      if (!validateFiles()) return;

      const formData = new FormData();
      formData.append("select_modification", data.modification_type?.label);
      formData.append("bank_id", data.bank_id?.value);
      formData.append("bank_number", data.bank_id?.account_number);
      formData.append("new_bank_name", data.new_bank_name.trim());
      formData.append("new_beneficiary_name", data.new_beneficiary_name.trim());
      formData.append("new_account_no", data.new_account_no.trim());
      formData.append("new_ifsc_code", data.new_ifsc_code.trim());

      Object.entries(files).forEach(([key, file]) => {
        if (file) formData.append(key, file);
      });

      const res = await dispatch(SubmitModifyBankInformation(formData));

      if (res.meta?.requestStatus === "fulfilled") {
        setModalMessage(res?.payload?.data || "Bank Information Modified Successfully");
        setModalShow(true);
        reset();
        setFiles(Object.fromEntries(Object.keys(files).map((k) => [k, null])));
        setPreviews(Object.fromEntries(Object.keys(previews).map((k) => [k, null])));
        setFileErrors({});
        setTimeout(() => {
          setModalShow(false);
          navigate(-1);
        }, 2000);
      } else {
        setModalMessage(
          res?.payload?.errors || "Submission failed. Please try again"
        );
        setModalShow(true);
        setTimeout(() => setModalShow(false), 3000);
      }
    } catch (error) {
      console.error("Modify Bank Information Error:", error);
    }
  };

  return (
    <>
      <section className="Modify_Bank_Information">
        <Common_white_header headingText={"Modify Bank Information"} />
        <Container>
          <Form onSubmit={handleSubmit(onSubmit)} noValidate>

            {/* ── Select Modification Type ── */}
            <Form.Group className="form-group field_holder">
              <Form.Label>
                Select Modification <span className="mandatory_estrics">*</span>
              </Form.Label>
              <Controller
                name="modification_type"
                control={control}
                rules={{ required: "Modification type is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={modificationOptions}
                    placeholder="Select modification type"
                  />
                )}
              />
              {errors.modification_type && (
                <small className="text-danger">
                  {errors.modification_type.message}
                </small>
              )}
            </Form.Group>

            {/* ── Select Bank ── */}
            <Form.Group className="form-group field_holder">
              <Form.Label>
                Select Bank <span className="mandatory_estrics">*</span>
              </Form.Label>
              <Controller
                name="bank_id"
                control={control}
                rules={{ required: "Bank is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    placeholder="Select Bank"
                    options={allBanks?.map((bank) => ({
                      value: bank?.id,
                      label: `${bank?.bank_name} - ${bank?.account_number}`,
                      account_number: bank?.account_number,
                    }))}
                  />
                )}
              />
              {errors.bank_id && (
                <small className="text-danger">{errors.bank_id.message}</small>
              )}
            </Form.Group>

            <hr />

            {/* ── NEW Bank Name ── */}
            <Form.Group className="form-group field_holder">
              <Form.Label>
                NEW Bank Name <span className="mandatory_estrics">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Please enter new bank name"
                {...register("new_bank_name", {
                  required: "New bank name is required",
                  minLength: {
                    value: 3,
                    message: "Bank Name must be at least 3 characters",
                  },
                  maxLength: {
                    value: 50,
                    message: "Bank Name cannot exceed 50 characters",
                  },
                  pattern: {
                    value: /^[A-Za-z\s]+$/,
                    message: "Bank Name can only contain letters and spaces",
                  },
                })}
              />
              {errors.new_bank_name && (
                <small className="text-danger">{errors.new_bank_name.message}</small>
              )}
            </Form.Group>

            {/* ── NEW Beneficiary Name ── */}
            <Form.Group className="form-group field_holder">
              <Form.Label>
                NEW Beneficiary Name <span className="mandatory_estrics">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Please enter beneficiary name"
                {...register("new_beneficiary_name", {
                  required: "Beneficiary name is required",
                  minLength: {
                    value: 3,
                    message: "Beneficiary Name must be at least 3 characters",
                  },
                  maxLength: {
                    value: 50,
                    message: "Beneficiary Name cannot exceed 50 characters",
                  },
                  pattern: {
                    value: /^[A-Za-z\s]+$/,
                    message: "Beneficiary Name can only contain letters and spaces",
                  },
                })}
              />
              {errors.new_beneficiary_name && (
                <small className="text-danger">
                  {errors.new_beneficiary_name.message}
                </small>
              )}
            </Form.Group>

            {/* ── NEW Account No ── */}
            <Form.Group className="form-group field_holder">
              <Form.Label>
                NEW Account No <span className="mandatory_estrics">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Please enter bank account number"
                {...register("new_account_no", {
                  required: "Account number is required",
                  pattern: {
                    value: /^[0-9]{9,18}$/,
                    message: "Enter a valid account number (9–18 digits)",
                  },
                })}
              />
              {errors.new_account_no && (
                <small className="text-danger">{errors.new_account_no.message}</small>
              )}
            </Form.Group>

            {/* ── NEW IFSC Code ── */}
            <Form.Group className="form-group field_holder">
              <Form.Label>
                NEW IFSC Code <span className="mandatory_estrics">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Please enter IFSC Code"
                {...register("new_ifsc_code", {
                  required: "IFSC Code is required",
                  pattern: {
                    value: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                    message: "Enter a valid IFSC Code (e.g. SBIN0001234)",
                  },
                })}
              />
              {errors.new_ifsc_code && (
                <small className="text-danger">{errors.new_ifsc_code.message}</small>
              )}
            </Form.Group>

            {/* ── Upload Fields ── */}
            {uploadFields.map((item) => (
              <Form.Group className="form-group field_holder" key={item.id}>
                <Form.Label>
                  {item.label}{" "}
                  {item.mandatory && (
                    <span className="mandatory_estrics">*</span>
                  )}
                </Form.Label>
                <div className="upload_box">
                  <input
                    type="file"
                    id={item.id}
                    hidden
                    accept={item.accept}
                    onChange={(e) => handleFileChange(e, item.id)}
                  />
                  <label htmlFor={item.id} className="photo_label">
                    {previews[item.id] && (
                      <div className="close-btn">
                        <FontAwesomeIcon
                          icon={faXmark}
                          onClick={(e) => {
                            // e.stopPropagation();
                            e.preventDefault();  // extra safety
                            setPreviews((prev) => ({
                              ...prev,
                              [item.id]: null,
                            }));
                          }}
                        />
                      </div>
                    )}
                    {previews[item.id] &&
                      previews[item.id] !== "file_uploaded" ? (

                      item.accept?.includes("video") ? (
                        <video
                          src={previews[item.id]}
                          className="uploaded_img_preview"
                          controls
                        />
                      ) : (
                        <img
                          src={previews[item.id]}
                          alt="Preview"
                          className="uploaded_img_preview"
                        />
                      )

                    ) : previews[item.id] === "file_uploaded" ? (
                      <div className="success_upload">
                        <FontAwesomeIcon
                          icon={faCloudUploadAlt}
                          style={{ color: "#28a745" }}
                        />
                        <span>Uploaded</span>
                      </div>

                    ) : (
                      <>
                        <FontAwesomeIcon icon={item.isFile ? faUpload : faCamera} />
                        <span>{item.isFile ? "Upload" : "Photo"}</span>
                      </>
                    )}
                  </label>
                </div>

                {/* ── Inline File Error ── */}
                {fileErrors[item.id] && (
                  <small className="text-danger">{fileErrors[item.id]}</small>
                )}
              </Form.Group>
            ))}

            {/* ── Submit ── */}
            <button
              type="submit"
              className="btn_register_bg"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Confirm"}
            </button>

          </Form>
        </Container>
      </section>

      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg={modalMessage}
      />
    </>
  );
}

export default Modify_Bank_Information;